import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { useNavigate, Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card } from "@/components/ui/card";
import { Sparkles, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handle = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(name, email, password);
      toast.success("Hesap oluşturuldu!");
      nav("/");
    } catch (err) {
      const detail = err.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Kayıt başarısız");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6">
      <Card className="w-full max-w-md p-8 shadow-xl">
        <div className="flex items-center gap-3 mb-6">
          <div className="h-10 w-10 rounded-xl bg-emerald-600 flex items-center justify-center text-white">
            <Sparkles className="h-5 w-5" />
          </div>
          <div className="text-xl font-bold" style={{ fontFamily: "Outfit" }}>HijyenPro</div>
        </div>
        <h1 className="text-3xl font-bold text-slate-900 mb-2" style={{ fontFamily: "Outfit" }}>Hesap Oluştur</h1>
        <p className="text-slate-500 mb-8">Temizlik şirketinizi yönetmeye başlayın</p>

        <form onSubmit={handle} className="space-y-5">
          <div>
            <Label htmlFor="name">Ad Soyad</Label>
            <Input id="name" required value={name} onChange={(e) => setName(e.target.value)}
                   data-testid="register-name-input" className="mt-1.5" />
          </div>
          <div>
            <Label htmlFor="email">E-posta</Label>
            <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                   data-testid="register-email-input" className="mt-1.5" />
          </div>
          <div>
            <Label htmlFor="password">Şifre (min 6 karakter)</Label>
            <Input id="password" type="password" required minLength={6} value={password}
                   onChange={(e) => setPassword(e.target.value)}
                   data-testid="register-password-input" className="mt-1.5" />
          </div>
          <Button type="submit" disabled={loading} data-testid="register-submit-button"
                  className="w-full bg-emerald-600 hover:bg-emerald-700 h-11">
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Kayıt Ol"}
          </Button>
        </form>

        <p className="text-center text-sm text-slate-500 mt-6">
          Zaten hesabınız var mı?{" "}
          <Link to="/login" className="text-emerald-700 font-medium hover:underline" data-testid="goto-login">
            Giriş yapın
          </Link>
        </p>
      </Card>
    </div>
  );
}
